import { mapGetters, mapActions } from 'vuex'

const mixin = {
  methods: {
    ...mapActions(['getSelectedOrders'])
  },
  computed: {
    ...mapGetters(['resultsSelectedOrders', 'resultsPdfList']),
    selectAll: {
      get: function () {
        if (this.resultsPdfList.orders.length === 0) {
          return false
        }
        return this.resultsPdfList.orders ? this.selected.length === this.resultsPdfList.orders.length : false
      },
      set: function (value) {
        var selected = []
        if (value) {
          this.resultsPdfList.orders.forEach(function (resultsPdfList) {
            resultsPdfList.examResultDateResponseList.forEach(function (result) {
              if (result.resultDate && result.visibleReport) {
                selected.push(result.idItemExam)
              }
            })
          })
        }
        this.selected = selected
      }
    },
    selected: {
      get: function () {
        return this.resultsSelectedOrders
      },
      set: function (value) {
        if (value) {
          this.getSelectedOrders(value)
        }
      }
    }
  },
  watch: {
    selected: function (newValue) {
      this.$emit('update:selected', newValue)
    }
  }
}

export default mixin
